"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guessUserCountry = exports.secToTimeUnits = exports.getPrettyDateRange = exports.getPrettyCalendarDateLong = exports.getPrettyCalendarDate = exports.getFilterFormattedDateString = exports.getFilterFormattedToDate = exports.getFilterFormattedFromDate = exports.getFormattedDateFromTimestamp = exports.getTimePeriodInDays = exports.getFormattedDateString = exports.prettyTimestamp = exports.getMomentInstance = void 0;
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
var moment_timezone_1 = require("moment-timezone");
var zones = require('moment-timezone/data/meta/latest.json').zones;
var getMomentInstance = function (timestamp, useUTC) {
    if (useUTC === void 0) { useUTC = true; }
    return useUTC ? (0, moment_1.default)(timestamp).utc() : (0, moment_1.default)(timestamp);
};
exports.getMomentInstance = getMomentInstance;
var prettyTimestamp = function (timestamp, timeAgo, withoutSuffix, withoutTime) {
    if (timeAgo === void 0) { timeAgo = false; }
    if (withoutSuffix === void 0) { withoutSuffix = false; }
    if (withoutTime === void 0) { withoutTime = false; }
    var date = new Date(timestamp);
    var momentInstance = (0, moment_1.default)(date);
    var formatMaybeTime = withoutTime ? 'll' : 'lll';
    return timeAgo ? momentInstance.fromNow(withoutSuffix) : momentInstance.format(formatMaybeTime);
};
exports.prettyTimestamp = prettyTimestamp;
var getFormattedDateString = function (date) {
    return (0, moment_1.default)(date, 'YYYY-MM-DD').format('YYYY-MM-DD').toString();
};
exports.getFormattedDateString = getFormattedDateString;
var getTimePeriodInDays = function (start, end) {
    var startDate = new Date(start);
    var endDate = new Date(end);
    var msPerDay = 1000 * 60 * 60 * 24;
    var utcStart = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var utcEnd = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    return Math.floor((utcEnd - utcStart) / msPerDay) + 1;
};
exports.getTimePeriodInDays = getTimePeriodInDays;
var getFormattedDateFromTimestamp = function (timestamp, daysOffset) {
    if (daysOffset === void 0) { daysOffset = 0; }
    return (0, moment_1.default)(timestamp).add(daysOffset, 'day').format('YYYY-MM-DD').toString();
};
exports.getFormattedDateFromTimestamp = getFormattedDateFromTimestamp;
var getFilterFormattedFromDate = function (fromDate) {
    var fromDateList = fromDate.split('-');
    return "".concat(fromDateList[0], "-").concat(fromDateList[1], "-").concat(fromDateList[2], "T00:00:00");
};
exports.getFilterFormattedFromDate = getFilterFormattedFromDate;
var getFilterFormattedToDate = function (toDate) {
    var toDateList = toDate.split('-');
    return "".concat(toDateList[0], "-").concat(toDateList[1], "-").concat(toDateList[2], "T23:59:59");
};
exports.getFilterFormattedToDate = getFilterFormattedToDate;
var getFilterFormattedDateString = function (date) {
    return (0, moment_1.default)(date, 'YYYY-MM-DDTHH:MM:SS').format('YYYY-MM-DDTHH:MM:SS').toString();
};
exports.getFilterFormattedDateString = getFilterFormattedDateString;
var getPrettyCalendarDate = function (uglyDate) {
    var date = new Date(uglyDate);
    var momentInstance = (0, moment_1.default)(date);
    return momentInstance.format('MMM Do YY');
};
exports.getPrettyCalendarDate = getPrettyCalendarDate;
var getPrettyCalendarDateLong = function (timestamp) {
    var date = new Date(timestamp);
    var momentInstance = (0, moment_1.default)(date);
    return momentInstance.format('MMMM D, YYYY');
};
exports.getPrettyCalendarDateLong = getPrettyCalendarDateLong;
var getPrettyDateRange = function (rangeStart, rangeEnd, t, isUtc) {
    if (isUtc === void 0) { isUtc = true; }
    var translateKey = 'app.common.date-range';
    var getNDaysAgo = function (days) { return (0, exports.getMomentInstance)(new Date().valueOf(), isUtc).subtract(days, 'days').format('D/M/YYYY'); };
    var currentHour = new Date().getHours();
    var isFirstHourOfTheDay = currentHour === 0;
    var firstHourFix = isFirstHourOfTheDay ? 1 : 0;
    if (rangeEnd !== getNDaysAgo(1) && rangeEnd !== getNDaysAgo(0)) {
        return "".concat(rangeStart, "-").concat(rangeEnd);
    }
    if (rangeEnd === getNDaysAgo(0) && rangeEnd === rangeStart) {
        return t("".concat(translateKey, ".today"));
    }
    if (rangeEnd === getNDaysAgo(1) && rangeStart === rangeEnd) {
        return t("".concat(translateKey, ".last-day"));
    }
    if (rangeStart === getNDaysAgo(7 - firstHourFix)) {
        return t("".concat(translateKey, ".7-days"));
    }
    if (rangeStart === getNDaysAgo(30 - firstHourFix)) {
        return t("".concat(translateKey, ".30-days"));
    }
    if (rangeStart === getNDaysAgo(60 - firstHourFix)) {
        return t("".concat(translateKey, ".60-days"));
    }
    if (rangeStart === getNDaysAgo(90 - firstHourFix)) {
        return t("".concat(translateKey, ".90-days"));
    }
    return "".concat(rangeStart, "-").concat(rangeEnd);
};
exports.getPrettyDateRange = getPrettyDateRange;
var secToTimeUnits = function (sec) {
    return ({
        seconds: sec % 60,
        minutes: Math.floor((sec / (60)) % 60),
        hours: Math.floor((sec / (60 * 60)) % 24)
    });
};
exports.secToTimeUnits = secToTimeUnits;
var guessUserCountry = function () {
    var _a, _b;
    var magicalTimezoneGuess = moment_timezone_1.tz.guess;
    return (_b = (_a = zones[magicalTimezoneGuess()]) === null || _a === void 0 ? void 0 : _a.countries[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
};
exports.guessUserCountry = guessUserCountry;
//# sourceMappingURL=index.js.map